import React, { useState, useEffect, useRef } from 'react';
import {
    TableCell,
    Typography,
    TableRow,
    Autocomplete
} from '@mui/material';
import ActionButtons from '../../dashboard/actionButtons';
import EditTextField from '../../../overrides/editField';
import { updateMenuItemMasterWatcher, deleteMenuItemMasterWatcher } from '../../../../redux/actionCreators/admin/menuItemMaster';
import { useDispatch, useSelector } from 'react-redux'
import { getMenuDropdownWatcher } from '../../../../redux/actionCreators/admin/menuMaster';


const MenuItemTableRow = ({ rowData, divisionId, setDisableEdit, disableEdit, page }) => {

    const dispatch = useDispatch();
    const { MenuMasterReducers: { mealDropdownList, menuDropdownList }, ProfileReducers: {loginState}, } = useSelector((state) => state)

    const userData = loginState[0] || {}
    const meal =( mealDropdownList.length && mealDropdownList[3] )|| []

    const [status, setStatus] = useState('list');
    const [editData, setEditData] = useState({});
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
    const [mealVal, setMealVal] = useState('')
    const tempinitsform = useRef();
    const tempinitform = useRef();
    const tempform = useRef();

    const requiredFields = ['nRate', 'nQuantity', 'cItemDesc', 'cItemName', 'nMenuID', 'nMealID']

    const initsform = () => {
        if (mealVal) {
            let data = { "NMEALID": `${mealVal}` }
            dispatch(getMenuDropdownWatcher(data))
        }
    };
    
    tempinitsform.current = initsform;
    
    useEffect(() => {
       tempinitsform.current();
    }, [mealVal]);

    // useEffect(() => {
    //     if (mealVal) {
    //         let data = { "NMEALID": `${mealVal}` }
    //         dispatch(getMenuDropdownWatcher(data))
    //     }

    // }, [mealVal])

    const initform = () => {
        setEditData(rowData)
    };
    
    tempinitform.current = initform;
    
    useEffect(() => {
       tempinitform.current();
    }, []);

    // useEffect(() => {
    //     setEditData(rowData)
    // }, [])

    const init = () => {
        setDisableEdit(false);
    };
    
    tempform.current = init;
    
    useEffect(() => {
       tempform.current();
    }, [page]);

    // useEffect(() => {
    //     setDisableEdit(false);
    // }, [page])

    const handleEditChange = (e) => {
        const { name, value } = e.target
        setEditData({ ...editData, [name]: value })
    }

    const handleEdit = () => {
        let data = { ...rowData }
        data.cMenuName = data.cMenuName[0]
        setEditData(data);
        setStatus('edit');
        setDisableEdit(true);
        // if(!mealVal){
        let data1 = { "NMEALID": `${rowData.nMealID}` }
        dispatch(getMenuDropdownWatcher(data1))

        // }
    }

    const handleDelete = async () => {
        let data = { "ACTION": "DELETE", SDIVISIONID: divisionId, }
        await dispatch(deleteMenuItemMasterWatcher(rowData.nID, { data }))
        setDeleteDialogOpen(false);
        setStatus('list');
    }

// ----------------------------------------------------------------------------------------------- submit func ---------------------------------------------------------------------------------------

    const tickIconFunction = async () => {
        let isValid = true
        let data = { ...editData, SDIVISIONID: divisionId, }
        data.ACTION = "MenuItemUpdate"

        await Object.keys(data).map((key, i) => {
            if (
                requiredFields.includes(key) &&
                (data[key] === null || data[key] === '' || data[key].length === 0)
            ) {
                isValid = false;
            }
            return null;
        });

        if (isValid) {
            await dispatch(updateMenuItemMasterWatcher(rowData.nID, data));
            setStatus('list');
            setDisableEdit(false);
        }
    }

    const cancelIconFunction = () => {
        setEditData({});
        setStatus('list');
        setDisableEdit(false);

    }

    let editMealList = meal.filter((a) => a.nMealApplicable === rowData.typeID) || []
    let editMealName = editMealList.find(m => m.id === rowData.nMealID) || {}

    return (
        <>
            <TableRow
                hover={status === 'list' ? true : false}
                tabIndex={-1}
            >
                {status === 'list' ?
                    <>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.ID}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.cMealName}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.cMenuName}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.cItemName}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.cItemDesc}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.cDivisionName}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.nQuantity}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.nRate}
                            </Typography>
                        </TableCell>
                    </>
                    :
                    <>
                        <TableCell align="left" >
                            <Typography variant='t14_600'>
                                {rowData.ID}
                            </Typography>
                        </TableCell>

                        <TableCell align="left">
                            <Autocomplete
                                id="combo-box-demo"
                                name="nMealID"
                                fullWidth
                                options={editMealList}
                                defaultValue={editMealName}
                                size="small"
                                autoHighlight
                                onChange={(event, value) => {
                                    setEditData({ ...editData, "nMealID": value.id });
                                    setMealVal(value.id);
                                }}
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) =>
                                    <EditTextField
                                        {...params}
                                        sx={{ minWidth: '160px' }}
                                        required={true}
                                        name='nMealID'
                                        error={editData.nMealID === '' ? true : false}
                                        helperText={editData.nMealID === '' ? 'Select Meal' : ''}
                                    />
                                }
                            />
                        </TableCell>

                        <TableCell align="left">
                            <Autocomplete
                                id="combo-box-demo"
                                name="nMenuID"
                                fullWidth
                                size="small"
                                autoHighlight
                                value={menuDropdownList.find(m => +m.id === +editData.nMenuID) || null}
                                // options={menuDropdownList}
                                options={menuDropdownList.filter(d=> d.cVendorID === editData.vendorID)}
                                onChange={(event, value) => {
                                    setEditData({ ...editData, "nMenuID": value.id });
                                }}
                                getOptionLabel={(option) => option.name}
                                renderInput={(params) =>
                                    <EditTextField
                                        {...params}
                                        sx={{ minWidth: '160px' }}
                                        required={true}
                                        name='nMenuID'
                                        error={editData.nMenuID === '' ? true : false}
                                        helperText={editData.nMenuID === '' ? 'Select Menu' : ''}
                                    />
                                }
                            />
                        </TableCell>

                        <TableCell align="left">
                            <EditTextField
                                name='cItemName'
                                required={true}
                                value={editData.cItemName}
                                onChange={handleEditChange}
                                error={editData.cItemName === '' ? true : false}
                                helperText={editData.cItemName === '' ? 'Item Name is required' : ''}
                            />
                        </TableCell>
                        <TableCell align="left">
                            <EditTextField
                                name='cItemDesc'
                                required={true}
                                value={editData.cItemDesc}
                                onChange={handleEditChange}
                                error={editData.cItemDesc === '' ? true : false}
                                helperText={editData.cItemDesc === '' ? 'Description is required' : ''}
                            />
                        </TableCell>
                        <TableCell align="left">
                            <Typography variant='t14_600'>
                                {rowData.cDivisionName}
                            </Typography>
                        </TableCell>
                        <TableCell align="left">
                            <EditTextField
                                name='nQuantity'
                                required={true}
                                value={editData.nQuantity}
                                onChange={handleEditChange}
                                error={editData.nQuantity === '' ? true : false}
                                helperText={editData.nQuantity === '' ? 'Quantity is required' : ''}
                            />
                        </TableCell>
                        <TableCell align="left">
                            <EditTextField
                                name='nRate'
                                required={true}
                                onChange={handleEditChange}
                                value={editData.nRate}
                                error={editData.nRate === '' ? true : false}
                                helperText={editData.nRate === '' ? 'Rate is required' : ''}
                            />
                        </TableCell>
                    </>
                }
                {Boolean(userData.cRoleName !== 'Admin') &&
                    <TableCell align="right">
                        <ActionButtons type={'menuMaster'} setStatus={setStatus} status={status} setEditData={setEditData} rowData={rowData} tickIconFunction={tickIconFunction} handleDelete={handleDelete} handleEdit={handleEdit} cancelIconFunction={cancelIconFunction} setDeleteDialogOpen={setDeleteDialogOpen} deleteDialogOpen={deleteDialogOpen} disableEdit={disableEdit} />
                    </TableCell>
                }
            </TableRow>
        </>
    )
}

export default MenuItemTableRow